export { DynamicComponentHostDirective } from './dynamic-component-host/dynamic-component-host.directive';
